import get from 'lodash/get';
import { NAV_FINISHED } from '../redux/nav';

import type { EventTracking, NavAction, Store } from '../types';

/** @type {NavFinishedActionType} */
export const pbr_nav_finished = 'pbr_nav_finished';

function navFinished(action: NavAction, state: Store) {
  let navPath = get(action, 'payload.path', []).slice();
  navPath.unshift(undefined);

  return {
    href: get(action, 'payload.href', ''),
    navLevel: navPath,
  };
}

const tracking: EventTracking = {};
tracking[NAV_FINISHED] = navFinished;

export default tracking;
